import { cn } from "@/utils/cn";

interface PricingTitleProps {
  className?: string;
  title: string;
}

function PricingTitle({ className, title }: PricingTitleProps) {
  return <div className={cn("text-24 font-semibold", className)}>{title}</div>;
}

export default PricingTitle;
